import React from 'react'
import {
  TestResult,
  useEditResultEventSample,
  EventAttendees,
  useAuth,
  UserPermissions,
  TestType,
} from '@modmd/data'
import { ApolloQueryResult } from '@apollo/client'
import { SelectInput } from 'components/SelectInput'
import Button from 'components/Button'
import Card from 'components/Card'
import { useToaster } from 'utils/useToaster'
import { isInfluenza } from 'utils/helpers'

interface Props {
  handleDismiss: () => void
  eventSampleId?: string | null
  result?: TestResult | null
  refetchAttendeesData: () => Promise<ApolloQueryResult<EventAttendees>>
  secondResult?: TestResult | null
  testType?: TestType
}

export const EditResultEventSample = ({
  eventSampleId,
  result,
  handleDismiss,
  refetchAttendeesData,
  secondResult,
  testType,
}: Props) => {
  const { hasPermission } = useAuth()
  const [testResult, setTestResult] = React.useState(result)
  const [secondTestResult, setSecondTestResult] = React.useState(secondResult)
  const [editTestResults, { loading }] = useEditResultEventSample()
  const { setToastMessage } = useToaster()

  const handleSave = async () => {
    try {
      await editTestResults({
        variables: {
          inputData: {
            result: testResult!,
            secondResult: secondTestResult!,
            eventSampleId: eventSampleId!,
          },
        },
      })
      handleDismiss()
      await refetchAttendeesData()
      setToastMessage('Result successfully edited', 'success')
    } catch {
      // ignore error
    }
  }
  return (
    <Card>
      <Card.Title>Change test result</Card.Title>
      <Card.Content>
        <SelectInput
          value={testResult || ''}
          disabled={!hasPermission([UserPermissions.ADD_EVENT_ATTENDEE_RESULT])}
          onChange={(event) => setTestResult(event.target.value as TestResult)}
          options={[
            { value: '', label: 'No result', disabled: true },
            ...Object.values(TestResult).map((value) => ({ value, label: value })),
          ]}
        />
        {isInfluenza(testType) && (
          <SelectInput
            value={secondTestResult || ''}
            disabled={!hasPermission([UserPermissions.ADD_EVENT_ATTENDEE_RESULT])}
            onChange={(event) => setSecondTestResult(event.target.value as TestResult)}
            options={[
              { value: '', label: 'No result', disabled: true },
              ...Object.values(TestResult).map((value) => ({ value, label: value })),
            ]}
          />
        )}
      </Card.Content>
      <Card.Actions>
        <Button
          isFetching={loading}
          disabled={testResult === result && secondTestResult === secondResult}
          onClick={handleSave}
        >
          Save
        </Button>
      </Card.Actions>
    </Card>
  )
}
